(() => {
 const header = document.querySelector('.vm-header');
 if (!header) return;
 const shell = header.querySelector('[data-vm-navigation]');
 const toggle = header.querySelector('[data-vm-toggle]');
 const close = header.querySelector('[data-vm-close]');
 const backdrop = document.querySelector('[data-vm-backdrop]');
 const menus = [...header.querySelectorAll('[data-vm-menu]')];
 const mobile = matchMedia('(max-width: 989px)');
 const fine = matchMedia('(hover:hover) and (pointer:fine)');
 let opener, timer;
 function syncBackdrop() { backdrop.hidden = !(!mobile.matches && menus.some(m => m.open)); }
 function closeMenus() { menus.forEach(m => m.open = false); syncBackdrop(); }
 function setDrawer(open) {
  toggle.setAttribute('aria-expanded', String(open));
  shell.dataset.open = String(open);
  shell.inert = mobile.matches && !open;
  document.body.classList.toggle('vy-navigation-open', mobile.matches && open);
  if (open) { opener = document.activeElement; close.focus(); } else { closeMenus(); opener?.focus(); }
 }
 toggle.addEventListener('click', () => setDrawer(toggle.getAttribute('aria-expanded') !== 'true'));
 close.addEventListener('click', () => setDrawer(false));
 backdrop.addEventListener('click', closeMenus);
 menus.forEach(menu => {
  const summary = menu.querySelector('summary');
  const panel = menu.querySelector('.vm-mega');
  summary.setAttribute('aria-controls', panel.id);
  summary.setAttribute('aria-expanded', String(menu.open));
  menu.addEventListener('toggle', () => { summary.setAttribute('aria-expanded', String(menu.open)); if (menu.open) menus.filter(m => m !== menu).forEach(m => m.open = false); syncBackdrop(); });
  menu.addEventListener('pointerenter', () => { if (!mobile.matches && fine.matches) { clearTimeout(timer); menus.filter(m => m !== menu).forEach(m => m.open = false); menu.open = true; } });
  menu.addEventListener('pointerleave', () => { if (!mobile.matches && fine.matches) timer = setTimeout(() => { menu.open = false; }, 140); });
 });
 shell.addEventListener('click', e => { if (e.target.closest('[data-vy-open],a')) { if (mobile.matches) setDrawer(false); else closeMenus(); } });
 document.addEventListener('click', e => { if (!header.contains(e.target)) closeMenus(); });
 document.addEventListener('keydown', e => {
  if (e.key === 'Escape') { const active = menus.find(m => m.open); if (mobile.matches && toggle.getAttribute('aria-expanded') === 'true') setDrawer(false); else if (active) { closeMenus(); active.querySelector('summary').focus(); } }
  if (e.key === 'Tab' && mobile.matches && toggle.getAttribute('aria-expanded') === 'true') {
   const items = [...shell.querySelectorAll('a,button,summary,input')].filter(el => el.getClientRects().length && !el.disabled);
   if (e.shiftKey && document.activeElement === items[0]) { e.preventDefault(); items.at(-1).focus(); } else if (!e.shiftKey && document.activeElement === items.at(-1)) { e.preventDefault(); items[0].focus(); }
  }
 });
 mobile.addEventListener('change', () => { setDrawer(false); shell.inert = mobile.matches;
 if (mobile.matches) document.querySelectorAll('.vm-footer-links details').forEach(d => d.open = false); });
 shell.inert = mobile.matches;
 if (mobile.matches) document.querySelectorAll('.vm-footer-links details').forEach(d => d.open = false);
 document.querySelectorAll('.vm-filter-panel').forEach(d => { d.open = !matchMedia('(max-width:749px)').matches || new URLSearchParams(location.search).has('size') || new URLSearchParams(location.search).has('color'); });
 document.addEventListener('click', e => {
  const button = e.target.closest('[data-vm-scene]');
  if (!button) return;
  const card = button.closest('.vy-card');
  const active = button.getAttribute('aria-pressed') !== 'true';
  card.classList.toggle('vm-show-detail',active);
  button.setAttribute('aria-pressed',String(active));
  const text = document.querySelector('#vm-labels');
  const labels = JSON.parse(text?.textContent || '{}');
  button.querySelector('[data-vm-scene-label]').textContent = active ? labels.scene : labels.pattern;
  button.setAttribute('aria-label', active ? labels.scene : labels.pattern);
 });
})();
